<template>
  <div class="goods-info-container">
    <div class="text1">货物信息</div>
    <div class="upload-box">
      <div class="text2">批量上传：</div>
      <el-upload
        class="upload-ordertable"
        drag
        :action="define.comUrl + '/api/file/Uploader/TemporaryFile'"
        :before-upload="handleBeforeUpload"
        :on-remove="fileHandleOnRemove"
        :on-success="(response, file, fileList) => handleSuccessFile(response, file, fileList)"
        :multiple="false"
        :file-list="fileList"
        accept=".xls,.xlsx"
      >
        <div class="flex upload-ordertable-item">
          <img src="@/assets/img/client/booking/upload.png" width="60" height="47">
          <span class="margin-left_10">点击上传填写好的订单表</span>
        </div>
        <div class="text2 margin-top_10 margin-bottom_10">文件后缀名仅支持xls或xlsx，大小不超过10MB，最多支持导入1000条数据</div>
        <div class="flex upload-ordertable-download" @click.stop="downloadTemplate">
          <div class="margin-left_30">FBA批量下单模板下载</div>
          <div class="download-icon-box">
            <img src="@/assets/img/client/booking/download.png" width="14" height="17">
          </div>
        </div>
      </el-upload>
    </div>
    <div>
      <div class="text2 margin-top_10 margin-bottom_10">在线填写：</div>
      <el-form ref="form" :model="ruleForm" :rules="rules" label-position="top">
        <div v-for="(spec, index) in ruleForm.volumeCargoList" :key="index" class="spec-item">
          <div class="box-specification">
            <div class="box-specification-title">箱规{{ index+1 }}</div>
            <div class="box-specification-content">
              <el-form-item class="input-item-box" label="箱号" :prop="`volumeCargoList.${index}.cartonNo`">
                <el-input v-model="spec.cartonNo" placeholder="非必填，为空则自动生成箱号" @blur="queryPrice" />
              </el-form-item>
              <el-form-item
                class="input-item-box"
                label="箱数"
                :prop="`volumeCargoList.${index}.quantity`"
                :rules="rules.quantity"
              >
                <el-input
                  v-model="spec.quantity"
                  :disabled="quantityDisabled(index,spec.cartonNo)"
                  @blur="queryPrice"
                />
              </el-form-item>
              <el-form-item
                class="input-item-box"
                label="FBA NO"
                :prop="`volumeCargoList.${index}.fbaNo`"
              >
                <el-input v-model="spec.fbaNo" placeholder="请输入FBA NO" />
              </el-form-item>
              <el-form-item class="input-item-box" label="预约号" :prop="`volumeCargoList.${index}.reId`">
                <el-input v-model="spec.reId" placeholder="请输入预约号" />
              </el-form-item>
              <el-form-item
                class="input-item-box"
                label="长"
                :prop="`volumeCargoList.${index}.length`"
                :rules="rules.length"
              >
                <el-input v-model="spec.length" placeholder="CM" @blur="queryPrice" />
              </el-form-item>
              <el-form-item
                class="input-item-box"
                label="宽"
                :prop="`volumeCargoList.${index}.width`"
                :rules="rules.width"
              >
                <el-input v-model="spec.width" placeholder="CM" @blur="queryPrice" />
              </el-form-item>
              <el-form-item
                class="input-item-box"
                label="高"
                :prop="`volumeCargoList.${index}.height`"
                :rules="rules.height"
              >
                <el-input v-model="spec.height" placeholder="CM" @blur="queryPrice" />
              </el-form-item>
              <el-form-item
                class="input-item-box"
                label="重量"
                :prop="`volumeCargoList.${index}.weight`"
                :rules="rules.weight"
              >
                <el-input v-model="spec.weight" placeholder="KG" @blur="queryPrice" />
              </el-form-item>
              <div style="width: 100%;">
                <div class="text3">货物申报信息</div>
                <div class="cargo-declaration-info">
                  <div class="cargo-declaration-cargoList">
                    <div v-for="(item,goodsIndex) in spec.cargoList" class="cargo-declaration-item">
                      <div>
                        <img :src="item.pictureUrl | toUrl()" width="64" height="64">
                      </div>
                      <div class="item-right">
                        <div>{{ item.nameCh }}</div>
                        <div>
                          <el-input
                            v-model="item.quantity"
                            size="mini"
                            type="number"
                            placeholder="单箱数量"
                          />
                          <span>件</span>
                        </div>
                      </div>
                      <i
                        class="el-icon-remove item-clear"
                        @click="removeGoods(index,goodsIndex)"
                      />
                    </div>
                  </div>
                  <div class="cargo-declaration-bottom">
                    <div class="flex add-btn" @click="addGoods(index)">
                      <div class="add-btn-icon">+</div>
                      <div class="add-btn-text">增加货物</div>
                    </div>
                    <div class="add-goods-btn" @click="editCommodity(index)">新增商品</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-remove">
            <div v-if="ruleForm.volumeCargoList.length > 1" class="box-del" @click="deleteBoxSpec">
              <i class="el-icon-delete margin-bottom_15" />
              <span class="margin-left_5">删除</span>
            </div>
            <div class="box-clear" @click="clearBoxSpec(index)">
              <i class="el-icon-remove-outline" />
              <span class="margin-left_5">清空</span>
            </div>
          </div>
        </div>
      </el-form>

      <div class="add-box-specification" @click="addvolumeCargoList">
        <i class="el-icon-circle-plus" />
        <span class="margin-left_5">增加箱规</span>
      </div>

      <div class="next-step">
        <button class="next-step-btn" @click.prevent="nextStep(2)">下一步</button>
      </div>
    </div>
    <EditDialog ref="editDialog" :value="isGoodsDialog" :append-to-body="true" @close="closeGoods">
      <template v-slot:title>
        <div>{{ goodsTitle }}</div>
      </template>
      <template v-slot:body>
        <div class="goods-search">
          <span>中文品名</span>
          <el-input v-model="commoditySearchKey" style="width: 390px;margin: 0 10px;" />
          <el-button type="primary" @click="searchCommodity">确定</el-button>
        </div>
        <el-table
          ref="tableRef"
          :data="commodityList"
          tooltip-effect="dark"
          header-row-class-name="tableheader"
          style="max-height: 460px;overflow: auto;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="nameCh" label="中文品名" align="left" />
          <el-table-column prop="brand" label="品牌" align="center" />
          <el-table-column prop="model" label="型号" align="center" />
          <el-table-column prop="productImage" label="商品图片" align="center">
            <template slot-scope="scope">
              <el-image style="width: 60px;height: 60px;" :src="scope.row.pictureUrl | toUrl()" />
            </template>
          </el-table-column>
          <el-table-column prop="goodsQuantity" label="单箱数量" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.quantity"
                style="width: 110px;text-align: center;"
                placeholder="请输入"
                size="mini"
                type="number"
                :min="0"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="editCommodity(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right;margin-top: 10px;"
          background
          layout="total, sizes, prev, pager, next"
          :total="commodityTotal"
          :page-sizes="[10,20,50]"
          @current-change="currentChange"
        />
        <div class="margin-top_20" style="text-align: right;width: 100%;">
          <el-button type="primary" @click="handleAddGoods">确定</el-button>
        </div>
      </template>
      <template v-slot:footer />
    </EditDialog>

    <EditDialog :value="isCommodityDialog" :append-to-body="true" @close="closeCommodity">
      <template v-slot:title>
        <div>{{ commodityTitle }}</div>
      </template>
      <template v-slot:body>
        <Commodity ref="commodity" :is-emit-data="true" @close="closeCommodity" @save="handleSaveCommodity" />
      </template>
      <template v-slot:footer />
    </EditDialog>
  </div>

</template>
<script>
import EditDialog from '@/components/Dialog/Dialog.vue'
import Commodity from '@/manage/produce/commodities/edit.vue'
import request from '@/utils/request'
import define from '@/utils/define'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    EditDialog,
    Commodity
  },
  data() {
    return {
      data: {},
      isGoodsDialog: false,
      isCommodityDialog: false,
      goodsTitle: '添加货物信息',
      commodityTitle: '新增商品',
      commodityList: [],
      commoditySearchKey: '',
      commodityTotal: 0,
      addGoodsIndex: 0,
      addcargoList: [],
      fileList: [],
      ruleForm: {
        volumeCargoList: [{
          cartonNo: undefined,
          weight: undefined,
          length: undefined,
          width: undefined,
          height: undefined,
          quantity: 1,
          fbaNo: undefined,
          reId: undefined,
          cargoList: []
        }]
      },
      rules: {
        quantity: [{
          required: true,
          message: '请填写箱数',
          trigger: 'blur'
        }],
        fbaNo: [{
          required: true,
          message: '请填FBA NO',
          trigger: 'blur'
        }],
        length: [{
          required: true,
          message: '请填写长度',
          trigger: 'blur'
        }],
        reId: [{
          required: true,
          message: '请填写预约号',
          trigger: 'blur'
        }],
        width: [{
          required: true,
          message: '请填写宽度',
          trigger: 'blur'
        }],
        height: [{
          required: true,
          message: '请填写高度',
          trigger: 'blur'
        }],
        weight: [{
          required: true,
          message: '请填写重量',
          trigger: 'blur'
        }]
      }
    }
  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    init(data) {
      this.data = data
      if (this.data.volumeCargoList && this.data.volumeCargoList.length > 0) {
        this.ruleForm.volumeCargoList = this.data.volumeCargoList
      }
    },
    addvolumeCargoList() {
      this.ruleForm.volumeCargoList.push({
        cartonNo: null,
        quantity: 1,
        fbaNo: null,
        reId: null,
        length: null,
        width: null,
        height: null,
        weight: null,
        cargoList: []
      })
      this.queryPrice()
    },
    deleteBoxSpec(index) {
      if (this.ruleForm.volumeCargoList.length > 1) {
        this.ruleForm.volumeCargoList.splice(index, 1)
      } else {
        this.$message.warning('至少保留一个箱规')
      }
    },
    clearBoxSpec(index) {
      const boxSpec = this.ruleForm.volumeCargoList[index]
      boxSpec.cartonNo = ''
      boxSpec.quantity = ''
      boxSpec.fbaNo = ''
      boxSpec.reId = ''
      boxSpec.length = ''
      boxSpec.width = ''
      boxSpec.height = ''
      boxSpec.weight = ''
    },
    searchCommodity() {
      request({
        url: `/api/Wms/OrderCargo/GetCustomerCargoList`,
        method: 'GET',
        headers: {
          Authorization: getCookie('token')
        },
        data: {
          name: this.commoditySearchKey
        }
      }).then(res => {
        this.commodityList = res.data
        this.commodityTotal = res.data.length
      })
    },
    quantityDisabled(index, cartonNo) {
      if (!cartonNo) {
        return false
      } else {
        this.ruleForm.volumeCargoList[index].quantity = 1
        return true
      }
    },
    handleSaveCommodity(data) {
      this.ruleForm.volumeCargoList[this.addGoodsIndex].cargoList.push(data)
    },
    addGoods(index) {
      this.isGoodsDialog = true
      this.goodsTitle = '添加货物信息'
      this.addGoodsIndex = index
      if (!(this.commodityList?.length > 0)) {
        this.searchCommodity()
      }

      this.$nextTick(() => {
        this.ruleForm.volumeCargoList[this.addGoodsIndex].cargoList.forEach(row => {
          this.$refs.tableRef.toggleRowSelection(row, true)
        })
      })
    },
    handleSelectionChange(val) {
      this.addcargoList = val
      console.log(this.addcargoList)
    },
    recoveryScroll() {
      this.$parent.recoveryScroll()
    },
    removeGoods(index, goodsIndex) {
      var row = this.ruleForm.volumeCargoList[index].cargoList[goodsIndex]
      this.ruleForm.volumeCargoList[index].cargoList.splice(goodsIndex, 1)
      this.addcargoList = this.addcargoList.filter(item => item.id !== row.id)
    },
    closeGoods() {
      this.isGoodsDialog = false
    },
    handleAddGoods() {
      this.ruleForm.volumeCargoList[this.addGoodsIndex].cargoList = this.addcargoList
      this.closeGoods()
    },
    editCommodity(commodityId) {
      this.isCommodityDialog = true
      // this.$parent.scrollToTop();
      const initId = commodityId || 0
      if (!initId) {
        this.commodityTitle = '新增商品'
      } else {
        this.commodityTitle = '编辑商品'
      }
      this.$nextTick(() => {
        this.$refs.commodity.init(commodityId)
      })
    },
    closeCommodity() {
      this.isCommodityDialog = false
    },
    currentChange(val) {
      console.log(val)
    },
    nextStep(index) {
      this.$nextTick(() => {
        this.$refs['form'].validate((val) => {
          if (val) {
            this.$parent.nextStep(index)
          }
        })
      })
    },
    queryPrice() {
      this.$emit('submitForm', this.ruleForm)
      this.$parent.queryPrice()
    },
    handleBeforeUpload(file) {
      const fileExtension = file.name.split('.').pop().toLowerCase()

      const isExcel = ['xls', 'xlsx'].includes(fileExtension)

      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('仅支持 xls 或 xlsx 格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }

      return isExcel && isLt10M
    },
    fileHandleOnRemove() {

    },
    handleSuccessFile(response, file, fileList) {
      var fileName = file.response.data.url.split('/').pop()
      request({
        url: `/api/shipping/Order/ImportPackingListPreview`,
        method: 'get',
        headers: {
          'Authorization': getCookie('token')
        },
        data: {
          fileName: fileName
        }
      }).then(res => {
        var importList = res.data.dataRow
        var packingListData = {
          customerId: this.data.customerId,
          data: importList
        }
        request({
          url: `/api/shipping/Order/ImportPackingListData`,
          method: 'post',
          headers: {
            'Authorization': getCookie('token')
          },
          data: packingListData
        }).then(res1 => {
          this.ruleForm.volumeCargoList = res1.data
          this.queryPrice()
        })
      })
    },
    downloadTemplate() {
      request({
        url: `/api/shipping/Order/PackingListTemplateDownload`,
        method: 'get',
        headers: {
          'Authorization': getCookie('token')
        }
      }).then(res => {
        this.xms.downloadFile(res.data.url)
      })
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 验证通过，触发自定义事件并传递表单数据
            this.$emit('submitForm', this.ruleForm) // 将表单数据作为参数传递
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.goods-info-container {
		width: 100%;
		padding: 20px;
		text-align: left;
		background: #ffffff;
		border-radius: 8px;
		box-sizing: border-box;

		.upload-box {
			padding: 10px 0 20px 0;
			border-bottom: 1px solid #E5E5E5;

			.upload-ordertable {
				text-align: center;
				background: #F8FBFC;
				border-radius: 20px;
				margin-top: 10px;
				border: 2px dashed #EBEBED;

				::v-deep .el-upload {
					width: 100%;
				}

				::v-deep .el-upload-dragger {
					border: none;
					width: 100%;
					text-align: center;
					border-radius: 20px;
					padding: 25px;
					height: auto;
					background: #F8FBFC;
				}

				.upload-ordertable-item {
					align-items: center;
					justify-content: center;
					color: #172031;
					font-size: 16px;
					font-weight: bold;
					cursor: pointer;
				}

				.upload-ordertable-download {
					width: 240px;
					padding: 5px;
					border-radius: 35px;
					border: 2px solid #DFE9FF;
					font-size: 14px;
					font-weight: bold;
					color: #1172FC;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin: 0px auto;
					margin-top: 20px;
					cursor: pointer;

					.download-icon-box {
						width: 48px;
						height: 48px;
						border-radius: 50%;
						background: #DFE9FF;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}
			}

		}

		.box-specification {
			margin: 10px 0;
			display: flex;
			border: 1px solid #E5EDFF;
			border-radius: 10px;

			.box-specification-title {
				width: 50px;
				background: #E5EDFF;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: space-around;
				border-radius: 10px 0 0 10px;
			}

			.box-specification-content {
				width: 860px;
				padding: 20px;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.input-item-box:nth-child(1),
				.input-item-box:nth-child(2),
				.input-item-box:nth-child(3),
				.input-item-box:nth-child(4) {
					width: 420px;
				}

				.input-item-box:nth-child(5),
				.input-item-box:nth-child(6),
				.input-item-box:nth-child(7),
				.input-item-box:nth-child(8) {
					width: 200px;
				}

				::v-deep .el-select,
				::v-deep .el-input,
				::v-deep .el-input__inner {
					background: #F4F5F7;
					border: none;
				}

				::v-deep .el-form-item__label {
					display: inline;
				}

				.cargo-declaration-info {
					width: 100%;
					box-sizing: border-box;
					background: #F6F8FA;
					margin-top: 5px;
					padding: 20px;
					border-radius: 4px;
					font-size: 14px;

					.cargo-declaration-cargoList {
						display: grid;
						grid-template-columns: repeat(3, 1fr);
						/* 关键属性：创建三个等宽列 */
						gap: 15px;
						/* 元素间距 */
						margin-bottom: 15px;

						.cargo-declaration-item {
							background: #ffffff;
							display: flex;
							font-size: 14px;
							padding: 10px 5px;
							position: relative;
							border-radius: 10px;

							.item-right {
								display: flex;
								flex-direction: column;
								justify-content: space-between;
								margin-left: 10px;

								::v-deep .el-select,
								::v-deep .el-input,
								::v-deep .el-input__inner {
									width: 110px;
									height: 24px;
									background: #ffffff;
									border: 1px solid #EEEEEE;
									border-radius: 4px;
									margin-right: 8px;
								}
							}

							.item-clear {
								position: absolute;
								right: -6px;
								top: -6px;
								font-size: 18px;
								border-radius: 50%;
								cursor: pointer;
								color: red;

							}
						}
					}

					.cargo-declaration-bottom {
						display: flex;
						justify-content: space-between;
						color: #3370FF;
						align-items: center;

						.add-btn {
							width: 75px;
							display: flex;
							justify-content: space-between;
							cursor: pointer;

							.add-btn-icon {
								width: 40px;
								height: 40px;
								display: flex;
								align-items: center;
								justify-content: center;
								background: #FFFFFF;
								border-radius: 4px;
								border: 1px dashed #3370FF;
							}

							.add-btn-text {
								width: 28px;
							}
						}

						.add-goods-btn {
							width: 128px;
							height: 32px;
							display: flex;
							align-items: center;
							justify-content: center;
							border: 1px solid #3370FF;
							color: #3370FF;
							border-radius: 8px;
							cursor: pointer;
						}

					}

				}

			}

		}

		.box-remove {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			font-size: 14px;

			div {
				width: 60px;
				height: 25px;
				line-height: 25px;
				text-align: center;
				border-radius: 4px;
			}

			.box-del {
				border: 1px solid #E9E9E9;
				color: #FC492D;
				cursor: pointer;
				margin-right: 10px;
				padding: 0 5px;
				font-size: 14px;
			}

			.box-clear {
				cursor: pointer;
				border: 1px solid #E9E9E9;
				color: #3370FF;
				padding: 0 5px;
				font-size: 14px;
			}
		}

		.add-box-specification {
			width: 100%;
			height: 35px;
			font-size: 14px;
			cursor: pointer;
			background: #F6F8FA;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #3370FF;
			font-weight: 500;
			margin-top: 10px;
		}

		.next-step {
			width: 100%;
			text-align: right;
			margin-top: 20px;

			.next-step-btn {
				width: 140px;
				height: 50px;
				font-size: 18px;
				background-color: #007BFF;
				color: white;
				border: none;
				border-radius: 3px;
				cursor: pointer;
			}
		}

		.text1 {
			font-size: 14px;
			font-weight: 500;
			color: #000000;
		}

		.text2 {
			font-size: 14px;
			font-weight: 400;
			color: #777777;
		}

		.text3 {
			font-size: 14px;
			font-weight: 400;
			color: #333333;
		}

	}

	.goods-search {
		display: flex;
		align-items: center;
		margin: 20px 0;
		font-size: 14px;
	}

	::v-deep .el-input__inner {
		padding-right: 0;
	}

	::v-deep .el-table th.el-table__cell {
		background: #F5F6F9;
		height: 50px;
	}

	::v-deep .dialog {
		width: 1032px;
		height: 715px;
		margin-top: 10vh;

		.dialog__header {
			text-align: left;
		}

		.dialog__body {
			padding: 0px;
		}

		.el-form-item--medium {
			width: 47%;
			margin-bottom: 0px
		}

		.commodities {
			height: auto;

			.main-info {
				padding: 0px;
			}
		}
	}
</style>
